import { createSelector } from 'reselect';

import { DeviceStatusEnum } from 'modules/devices/constants';
import { getState as getParent } from 'modules/hardwares/selectors/ui';
import { filterRequestFormatter } from 'modules/interventions/utils';
import { getSelectedDealerId } from 'selectors/dealerSelectors';

const getState = createSelector(getParent, ui => ui.dashboard);

export const getIds = createSelector(getState, dashboard => dashboard.ids);

export const getPage = createSelector(getState, ({ page }) => page);

export const hasNextPage = createSelector(getPage, page => !!page.last);

export const isFetching = createSelector(getState, state => state.isLoading);

const getFilters = createSelector(getState, dashboard => dashboard.filters);

export const isCreateModalOpen = createSelector(getState, dashboard => dashboard.creationModal.isOpen);
export const modalSelectedHardware = createSelector(getState, dashboard => dashboard.creationModal.selectedHardware);

export const getBaseRequestParams = createSelector(
  getSelectedDealerId,
  getFilters,
  (dealerId, filters) => ({
    status: [DeviceStatusEnum.ACTIVE, DeviceStatusEnum.INACTIVE],
    dealerId,
    ...filterRequestFormatter(filters),
  })
);
